











































import Vue from 'vue'
import Component from 'vue-class-component'
import { isRespondeco } from '@/config/environments'

@Component({
  name: 'respondeco-footer',
})
export default class RespondecoFooter extends Vue {
  isRespondeco = isRespondeco()
}
